module.exports = __webpack_public_path__ + "static/media/MK 19-20.96bc49fb.mp3";